module.exports = __webpack_public_path__ + "img/solicitations.e7b5932b.svg";